export const absenceRequestsSelector = state => state.absenceRequests;
